export const getAccessoryConflictIds = bikeAccessories =>
  bikeAccessories.reduce(
    (prevAccessoryConflictIds, accessory) => [
      ...prevAccessoryConflictIds,
      ...accessory.conflicts.filter(accessoryId => !prevAccessoryConflictIds.includes(accessoryId)),
    ],
    []
  );

export const getPackAccessoryConflicts = (pendingPack, bikeAccessories) => {
  const packPartIds = pendingPack.parts.map(part => part.id);

  return bikeAccessories.filter(
    accessory =>
      accessory.conflicts.find(accessoryId => packPartIds.includes(accessoryId)) ||
      (packPartIds.includes(accessory.id) && !accessory.allowMultiple)
  );
};

export const combineDuplicateAccessories = accessories =>
  accessories.reduce((prevCombinedAccessories, accessory) => {
    const prevAccessory = prevCombinedAccessories.find(
      prevCombinedAccessory => prevCombinedAccessory.id === accessory.id
    );

    // don't combine pack accessories with non pack accessories
    if (prevAccessory) {
      prevAccessory.quantity += 1;

      if (accessory.pack) {
        prevAccessory.pack = true;
      }

      return prevCombinedAccessories;
    }

    return [...prevCombinedAccessories, accessory];
  }, []);

export const cleanAccessories = accessories =>
  accessories.map(accessory => ({
    ...accessory,
    quantity: accessory.quantity ? accessory.quantity : 1,
    pack: Boolean(accessory.pack),
  }));

export const removeDuplicateAccessories = accessories => {
  const accessoryIds = accessories.map(accessory => accessory.id);

  return accessories.filter((accessory, index) => accessoryIds.indexOf(accessory.id) === index);
};

export const getConflictingAccessories = (pendingAccessories, bikeAccessories, packAccessories) => {
  if (!Array.isArray(pendingAccessories) || !pendingAccessories.length) {
    return [];
  }

  const allBikeAccessories = [...bikeAccessories, ...packAccessories];

  // If content hasn't been entered properly i.e. accessory A conflicts with
  // Accessory B, but B doesn't conflict with A, then we need to find the
  // conflicts from existing accessories
  const existingAccessoriesConflicting = allBikeAccessories.filter(accessory =>
    accessory.conflicts.includes(pendingAccessories[0].id)
  );

  return pendingAccessories[0].conflicts
    .filter(accessoryId => allBikeAccessories.map(accessory => accessory.id).includes(accessoryId))
    .map(accessoryId => allBikeAccessories.find(accessory => accessory.id === accessoryId))
    .concat(existingAccessoriesConflicting)
    .filter(
      (accessory, index, newPendingAccessories) =>
        newPendingAccessories.map(ac => ac.id).indexOf(accessory.id) === index
    );
};

export const flattenAccessoriesConflictingIds = accessories =>
  accessories.reduce(
    (prevAccessoryIds, accessory) => [
      ...prevAccessoryIds,
      ...accessory.conflicts.filter(accessoryId => prevAccessoryIds.indexOf(accessoryId) === -1),
    ],
    []
  );

export const getPendingConflictingAccessories = (conflictingAccessories, pendingAccessories) => {
  // For all existing accessories on bike (with which new accessories conflict)
  // combine their conflicts
  const conflictingAccessoriesConflictIds = flattenAccessoriesConflictingIds(conflictingAccessories);

  const conflictingAccessoryIds = conflictingAccessories.map(accessory => accessory.id);

  // Compare those conflicts with pending accessories to work out which
  // of the pending accessories relate to the conflict
  const pendingConflictingAccessories = pendingAccessories.filter(
    pendingAccessory =>
      conflictingAccessoriesConflictIds.includes(pendingAccessory.id) ||
      pendingAccessory.conflicts.some(accessoryId => conflictingAccessoryIds.includes(accessoryId))
  );

  return pendingConflictingAccessories;
};

export const flattenAccessoriesRequiresSingleIds = accessories =>
  accessories.reduce(
    (prevAccessoryIds, accessory) => [
      ...prevAccessoryIds,
      ...accessory.requiresSingle.filter(accessoryId => prevAccessoryIds.indexOf(accessoryId) === -1),
    ],
    []
  );

export const flattenAccessoriesRequiresAllIds = accessories =>
  accessories.reduce(
    (prevAccessoryIds, accessory) => [
      ...prevAccessoryIds,
      ...accessory.requiresAll.filter(accessoryId => prevAccessoryIds.indexOf(accessoryId) === -1),
    ],
    []
  );
